exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dynamic-select{height:48px;border-radius:3px;border:1px solid #dee2e6;color:#979797;background:#fff url(\"data:image/svg+xml;utf8,<svg width='1em' height='1em' role='img' xmlns='http://www.w3.org/2000/svg' fill='979797'><path d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'></path></svg>\") no-repeat right .75rem center;background-size:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-44414ac2","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/DynamicForms/Select.vue
// module id = 800
// module chunks = 43